import { SortOrder } from "../types";
import {
  MOVIE_KEY,
  ONLY_FAVORITES_KEY,
  ONLY_SEEN_KEY,
  SORT_KEY,
  STORAGE_KEY,
} from "./constants";

export const get = () => {
  const existingDataText = localStorage.getItem(STORAGE_KEY);
  const existingData = JSON.parse(existingDataText || "{}");
  return {
    [MOVIE_KEY]: {
      seen: [],
      favorited: [],
      ...existingData[MOVIE_KEY],
    },
    [SORT_KEY]: existingData[SORT_KEY],
    [ONLY_SEEN_KEY]: existingData[ONLY_SEEN_KEY] || false,
    [ONLY_FAVORITES_KEY]: existingData[ONLY_FAVORITES_KEY] || false,
  } as {
    [MOVIE_KEY]: { seen: string[]; favorited: string[] };
    [SORT_KEY]: keyof typeof SortOrder;
    [ONLY_SEEN_KEY]: boolean;
    [ONLY_FAVORITES_KEY]: boolean;
  };
};

export const set = (data: any) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};
